import React from 'react';
import PropTypes from 'prop-types';
import { RideFiInactivityLight } from '@rimac-seguros/ride-system-components';
import useBreakpoint from '../../../hooks/useBreakpoint';

import { Button } from '../../atoms';
import Card from '../../../assets/error/full-ic-error-card.svg';

const ModalPaymentError = ({ onClose, isTimeout }) => {
  const isDesktop = useBreakpoint('large-min');
  return (
    <div className="modal-payment-error">
      {isTimeout ? (
        <RideFiInactivityLight size={isDesktop ? 'x-large' : 'small'} />
      ) : (
        <img src={Card} alt="error tarjeta" />
      )}
      <h2>{isTimeout ? 'Tu sesión ha expirado' : 'No hemos logrado procesar tu pago'}</h2>
      <p>{isTimeout ? 'Estuviste inactivo por unos minutos. Por seguridad tu sesión expiró. Por favor, vuelve a iniciar sesión.' : 'Por favor intenta nuevamente'}</p>
      <div className="modal-payment-button">
        <Button
          label={isTimeout ? 'Entendido' : 'Reintentar'}
          onClick={onClose}
          type="primary"
        />
      </div>
    </div>
  );
};

ModalPaymentError.propTypes = {
  onClose: PropTypes.func.isRequired,
  isTimeout: PropTypes.bool,
};

ModalPaymentError.defaultProps = {
  isTimeout: false,
};

export default ModalPaymentError;
